import React, { Suspense } from "react";
import "@/styles/global.css";

import Header from "@/components/Header/Header";
import Footer from "@/shared/Footer/Footer";
import Loading from "./loading";
import { CartProvider } from "@/context/CartContext";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <CartProvider>
      <Header />
      <Suspense fallback={<Loading />}>{children}</Suspense>
      <Footer />
    </CartProvider>
  );
};

export default Layout;
